import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ModalDialog } from '@marvelapp/ui';
import { DeleteButton } from './DeleteButton';
export function DeleteModal({ buttonText, isOpen, trigger, title = 'Are you sure?', children, handleFormSubmit, hideConfirmationForm, }) {
    return (_jsx(ModalDialog, { isOpen: isOpen, title: title, trigger: trigger, children: _jsxs(Box, { p: 25, children: [children, hideConfirmationForm ? null : (_jsx(DeleteButton, { buttonText: buttonText, handleFormSubmit: handleFormSubmit }))] }) }));
}
